import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { msalInstance } from '../index';
import { appInsights } from './ApplicationInsightsService';

export async function getAccessToken(): Promise<string> {
    const accounts = msalInstance.getAllAccounts();
    const accessTokenRequest = {
        scopes: [process.env.REACT_APP_MSAL_CLIENT_ID + '/.default'],
        account: accounts[0],
    };

    try {
        const response = await msalInstance.acquireTokenSilent(accessTokenRequest);
        return response.accessToken;
    } catch (error: any) {
        if (error instanceof InteractionRequiredAuthError) {
            msalInstance.acquireTokenRedirect(accessTokenRequest);
        } else {
            appInsights.trackException({ exception: error });
            console.error('Could not obtain access token', error);
        }
        throw error;
    }
}
